import { DateTime } from '@ksyos/date-time';
import { Alert } from '@ksyos/design-system';
import { ProcessActivityReadContext } from '@frontend/components/pages/episodeCategory/carePath/process/processActivity/processActivityRead/processActivityReadContext';
import { ReadForm } from '@frontend/formEngine/readForm/ReadForm';
import { useDefinedContext } from '@frontend/utils/hooks/useDefinedContext';

export function HolterAnalysisReportRead(): JSX.Element {
    const { processActivity } = useDefinedContext(ProcessActivityReadContext);

    return (
        <>
            <ReadForm />
            {processActivity.lastModifiedDateTime && (
                <Alert appearance="info">
                    Er heeft op {DateTime.from(processActivity.lastModifiedDateTime).format('DD-MM-YYYY [om] HH:mm')}{' '}
                    een nieuwe upload van het rapport plaatsgevonden. Hier vind je het nieuwste rapport.
                </Alert>
            )}
        </>
    );
}
